module.exports = __webpack_public_path__ + "static/media/collab.a20856ce.png";